import { View } from 'react-native';

import { Text, createMqStyles, useMqSelect } from '@fhs/ui';

export function ChallengesSectionHeader() {
  const mqStyles = useMqStyles();

  return (
    <View style={mqStyles.container}>
      <Text.Heading type={useMqSelect({ $gteDesktop: 'one' }, 'three')}>Challenges</Text.Heading>
    </View>
  );
}

const useMqStyles = createMqStyles({
  container: {
    $base: {
      flexDirection: 'row',
      marginTop: 16,
      alignItems: 'center',
    },
  },
});
